export default __webpack_public_path__ + "static/media/p1_xPlayzIcon.b74e0fee.png";